// Sunucunun ResponseBase.ResponseCode degerleri.
//
// C# karsiligi: arkmanwebcore/ArkmanWeb/ArkmanCore/Models/ResponseBase.cs
// icindeki "MesajKodu" sinifi. Yeni bir kod aciliyorsa IKI taraf birlikte
// guncellenir.
//
// NEDEN KOD VAR: ResponseMessage kullaniciya gosterilen METIN. Arayuzun o mesaja
// gore DAVRANIS secmesi gerektiginde (ornegin "biletin son halini getir"
// teklifini acmak) metne bakmak kirilgan -- metin C# icinde sabit Turkce,
// arayuz ise 5 dilli; bir kelime degisince esleme SESSIZCE kopar ve teklif bir
// daha hic acilmaz. Kod bu esleme icin.
//
// Yalnizca arayuzde davranis gerektiren hatalara kod aciliyor; digerlerinde alan
// hic gelmez (undefined) ya da null olur.
export const MESAJ_KODU = {
  // Bilet, ekranda acikken bir baskasi tarafindan degistirilmis (sunucudaki
  // FTimeStamp uyusmuyor). KAYIT YAPILMADI, veri bozulmadi; kullaniciya biletin
  // son halini getirmek teklif edilir.
  BILET_DEGISMIS: "BILET_DEGISMIS",
};

export default MESAJ_KODU;
